import Header from './Header'
import Footer from './Footer'
import Tips from './Tips'
import type {SearchKind, SearchKindCount} from '../../hooks/use-search-result-counts'
import {generateTips} from './data'
import MonaSearchImage from './MonaSearchImage'
import styles from './NoResults.module.css'

export default function NoResults({
  resultKind,
  searchKinds,
  isLoadingCounters,
}: {
  resultKind: SearchKind
  searchKinds: SearchKindCount[]
  isLoadingCounters: boolean
}) {
  return (
    <div data-hpc className={styles.container}>
      <div className={styles.imageWrapper}>
        <div className={styles.imageFlex}>
          <div className={styles.imageContainer}>
            <MonaSearchImage />
          </div>
        </div>
      </div>
      <div className={styles.contentColumn}>
        <Header resultKind={resultKind} searchKinds={searchKinds} isLoadingCounters={isLoadingCounters} />
        <Tips data={generateTips({resultKind})} />
        <div className={styles.footerWrapper}>
          <Footer resultKind={resultKind} />
        </div>
      </div>
    </div>
  )
}
